import { memo } from "react";

const IconComponent = memo(({ icon }) => {
  return (
    <img
      src={icon}
      alt="icon"
      className="w-[18px] flex-shrink-0 me-2"
    />
  );
});

export default IconComponent;
